import { detectOS } from 'detect-browser';

export type PlatformSelect<T> = {
  macos?: T;
  windows?: T;
  linux?: T;
  default?: T;
};

const { userAgent } = navigator;

export const selectByOS = <T>(data: PlatformSelect<T>): T => {
  const os = detectOS(userAgent);

  if (/mac/i.test(os)) {
    return data.macos || data.default;
  }

  if (/linux/i.test(os)) {
    return data.linux || data.default;
  }

  if (/windows/i.test(os)) {
    return data.windows || data.default;
  }

  return data.default;
};
